import isNull from "../utils/NullChecking";

const initialState = {
  activeRecordingEncounterId: null, // Lock — the single encounter ID currently recording, or null if none
  duration: 0,
  openAIPopup: false,
};

const ResumeAISessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_RECORDING_TIMER": {
      const { encounterId, duration } = action.payload;
      return {
        ...state,
        activeRecordingEncounterId: encounterId,
        duration
      };
    }
    case "OPEN_AI_POPUP": {
      const { openAIPopup } = action.payload;
      return {
        ...state,
        openAIPopup
      };
    }

    case "RECORDING_STOPPED": {
      const { encounterId } = action.payload;
      const activeRecordingEncounterId = state?.activeRecordingEncounterId;
      const shouldClearEncounter = !isNull(encounterId) && (encounterId == activeRecordingEncounterId);
      if (!shouldClearEncounter) {
        return state;
      }
      return {
        ...state,
        activeRecordingEncounterId: null,
        duration: 0,
      };
    }

    default:
      return state;
  }
};

export default ResumeAISessionReducer;